import { useEffect, useState } from 'react';
import { ModuleConfig } from '../components/Module';

export const DEFAULT_MODULE_MANIFEST = '/moduleManifest.json';

export type ModuleManifestConfig = ModuleConfig & { name: string };
export type ModuleManifest = ModuleManifestConfig[];

export const useModuleManifestFactory = () => {
  let moduleManifest: ModuleManifest = [];

  /**
   * For name-based module resolution from a manifest. Call at the base, pass in the url to the manifest
   * @param manifestUrl the url to the manifest file in JSON format
   * @returns the module manifest
   */
  const useModuleManifest = (manifestUrl?: string) => {
    const [, setModuleManifestLoaded] = useState(false);

    const loadModuleManifest = async (url: string) => {
      const manifestResponse = await fetch(url);
      const manifestJson = await manifestResponse.json();
      const manifestParsed = JSON.parse(manifestJson);
      moduleManifest = manifestParsed;
      setModuleManifestLoaded(true);
    };

    useEffect(() => {
      if (manifestUrl) {
        loadModuleManifest(manifestUrl);
      }
    }, []);

    return moduleManifest;
  };
  return useModuleManifest;
};

/**
 * For name-based module resolution from a manifest. Call at the base, pass in the url to the manifest
 * @param manifestUrl the url to the manifest file in JSON format
 * @returns the module manifest
 */
export const useModuleManifest = useModuleManifestFactory();
